import { render, staticRenderFns } from "./BaseOverlayMenuListTitle.vue?vue&type=template&id=4a3b8cac"
import script from "./BaseOverlayMenuListTitle.vue?vue&type=script&lang=js"
export * from "./BaseOverlayMenuListTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseOverlayMenuListTitle.vue?vue&type=style&index=0&id=4a3b8cac&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports